<div ng-controller="channelActionController as ctrl" class="channel-action">
    <div class="modal-view">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>